export default __webpack_public_path__ + "static/media/courses.940bf79b.svg";